module.exports = __webpack_public_path__ + "static/media/ZIYUAN 3-2 (ZY 3-2).77ab6a8c.czml";